import { render, staticRenderFns } from "./TeamImageUploader.component.vue?vue&type=template&id=ebcb4fc4&scoped=true"
import script from "./TeamImageUploader.component.vue?vue&type=script&lang=js"
export * from "./TeamImageUploader.component.vue?vue&type=script&lang=js"
import style0 from "./TeamImageUploader.component.vue?vue&type=style&index=0&id=ebcb4fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcb4fc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
